<app-header></app-header>

<div class="main-container">
    <div class="breadcrumb-section">
        <section>
            <nav>
                <ol class="cd-breadcrumb custom-separator custom-icons">
                    <li><a routerLink="/dashboard"><i class="fa-solid fa-house"></i></a></li>
                    <li><a routerLink="/generate"><i class="fa-solid fa-table-columns"></i>Metadata Overview</a></li>
                    <li class="current"><a><i class="fa fa-sitemap" aria-hidden="true"></i> Classification and
                            Description Generation</a></li>
                    <li class="breadcrumb-final"><i class="fa-solid fa-square-poll-vertical"></i> Final Output</li>
                </ol>
            </nav>
        </section>
    </div>

    <mat-card appearance="outlined" class="progress-card">
        <mat-card-header class="card-header-flex">
            <div class="header-content">
                <mat-card-title class="card-title">Review AI generated
                    classifications</mat-card-title>
            </div>
            <div class="header-actions">
                <button class="btn btn-success generate-btn save-btn" (click)="saveMetadata()">
                    <i class="fa-solid fa-save"></i>&nbsp;Save & Return to Home
                </button>
                <button class="btn btn-primary generate-btn download-btn margin-left" (click)="openDownloadOptions()">
                    <i class="fa-solid fa-download"></i>&nbsp;Download Output
                </button>
            </div>
        </mat-card-header>
        <mat-card-content class="progress-content">
            <div class="completion-info">
                <span class="completion-text">Completion</span>
                <span class="completion-percentage">90%</span>

            </div>
            <div class="progress progress-bar-container">
                <div class="progress-bar progress-bar-filled" role="progressbar" aria-valuemin="0" aria-valuemax="100"
                    [style.width.%]="90" [attr.aria-valuenow]="90"></div>
            </div>
        </mat-card-content>
    </mat-card>
</div>

<div class="container1">
    <div class="box main-content-box">
        <div class="dashboard-content-2 content-wrapper" *ngIf="!descriptionLoading">
            <mat-tab-group mat-stretch-tabs class="example-stretched-tabs mat-elevation-z4">
                @for (item of newResponse; track $index){
                <mat-tab label="{{item.table_name}}">
                    <div>
                        <div class="table-info-section">
                            <span class="info-chip database-info">
                                <i class="fa fa-database" aria-hidden="true"></i>
                                <span [matTooltip]="item.database_name" matTooltipPosition="above"
                                    matTooltipShowDelay="300">{{item.database_name.substring(0, 20)}}
                                    <span *ngIf="item.database_name.length>20">...</span></span>
                                <i class="fa fa-sitemap" aria-hidden="true"></i>
                                <span [matTooltip]="item.schema_name" matTooltipPosition="above"
                                    matTooltipShowDelay="300">{{item.schema_name.substring(0, 20)}}
                                    <span *ngIf="item.schema_name.length>20">...</span>
                                </span>
                                <i class="fa fa-table" aria-hidden="true"></i>
                                <span [matTooltip]="item.table_name" matTooltipPosition="above"
                                    matTooltipShowDelay="300">{{item.table_name.substring(0, 20)}}<span
                                        *ngIf="item.table_name.length>20">...</span></span>
                            </span>

                            <span class="info-chip domain-info">
                                <b>Domain:</b>
                                @if(item.isDomainEditable){
                                <input type="text" matInput [(ngModel)]="item.table_metadata.domain" class="mx-1" />
                                <i class="fa fa-save action-icon" (click)="saveHeader('domain', $index)"></i>
                                }
                                @if(!item.isDomainEditable){
                                <span [matTooltip]="item.table_metadata.domain" matTooltipPosition="above"
                                    matTooltipShowDelay="300">{{item.table_metadata.domain.substring(0, 10)}}<span
                                        *ngIf="item.table_metadata.domain.length>10">...</span></span>
                                <span *ngIf="item.table_metadata.domain==''" class="text-muted fst-italic">
                                    Empty
                                </span>
                                <i class="fas fa-edit" (click)="editHeader('domain', $index)"></i>
                                }
                            </span>

                            <span class="info-chip business-type-info">
                                <b>Business Type:</b>
                                @if(item.isBusinessTypeEditable){
                                <input type="text" matInput [(ngModel)]="item.table_metadata.business_type"
                                    class="mx-1" />
                                <i class="fa fa-save action-icon" (click)="saveHeader('businessType', $index)"></i>
                                }
                                @if(!item.isBusinessTypeEditable){
                                <span [matTooltip]="item.table_metadata.business_type" matTooltipPosition="above"
                                    matTooltipShowDelay="300">{{item.table_metadata.business_type.substring(0,
                                    10)}}<span *ngIf="item.table_metadata.business_type.length>10">...</span></span>
                                <span *ngIf="item.table_metadata.business_type==''" class="text-muted fst-italic">
                                    Empty
                                </span>
                                <i class="fas fa-edit" (click)="editHeader('businessType', $index)"></i>
                                }
                            </span>

                            <span class="info-chip description-info">
                                <b>Table Description Instruction:</b>
                                <span class="margin-left">
                                    @if(item.isTableDescriptionEditable){
                                    <input type="text" matInput [(ngModel)]="item.table_metadata.user_table_description"
                                        class="mx-1" />
                                    <i class="fa fa-save action-icon" (click)="saveHeader('description', $index)"></i>
                                    }
                                    @if(!item.isTableDescriptionEditable){
                                    <span [matTooltip]="item.table_metadata.user_table_description"
                                        matTooltipPosition="above"
                                        matTooltipShowDelay="300">{{item.table_metadata.user_table_description.substring(0,
                                        10)}}<span
                                            *ngIf="item.table_metadata.user_table_description.length>10">...</span></span>
                                    <span *ngIf="item.table_metadata.user_table_description==''"
                                        class="text-muted fst-italic">
                                        Empty
                                    </span>
                                    <i class="fas fa-edit" (click)="editHeader('description', $index)"></i>
                                    }
                                </span>
                            </span>

                            @if(newResponse.length>1){
                            <span matTooltip="Delete" (click)="deleteTable(item,'0ms', '0ms')" class="delete-chip">
                                <i class="fa-solid fa-trash"></i>
                            </span>
                            }
                            <span class="action-buttons">
                                <button class="btn btn-primary generate-btn table-download-btn margin-left"
                                    (click)="exportCsv(item.table_name,item?.columns)">
                                    <i class="fa-solid fa-download"></i>&nbsp;Download
                                </button>
                                <button class="btn btn-primary generate-btn table-regenerate-btn"
                                    (click)="regenerateMetadata(item)">
                                    <i class="fa-solid fa-repeat"></i>&nbsp;Regenerate
                                </button>
                            </span>
                        </div>

                        <table mat-table [dataSource]="item.dataSource" class="mat-elevation-z8 data-table">
                            <colgroup>
                                <col style="width: 5%;">
                                <col style="width: 10%;">
                                <col style="width: 10%;">
                                <col style="width: 20%;">
                                <col style="width: 20%;">
                                <col style="width: 5%;">
                                <col style="width: 20%;">
                                <col style="width: 5%;">
                                <col style="width: 5%;">
                            </colgroup>
                            <ng-container matColumnDef="select">
                                <th mat-header-cell *matHeaderCellDef>
                                    <mat-checkbox class="my-white-unchecked"
                                        (change)="$event ? toggleAllRows($event,item) : null" [checked]="item.checked">
                                    </mat-checkbox>
                                </th>
                                <td mat-cell *matCellDef="let row">
                                    <mat-checkbox (click)="$event.stopPropagation()"
                                        (change)="checkRow($event, row, item)" [checked]="row.checked">
                                    </mat-checkbox>
                                </td>
                            </ng-container>

                            <ng-container matColumnDef="columnName">
                                <th mat-header-cell *matHeaderCellDef> Column Name </th>
                                <td mat-cell *matCellDef="let element; let i = index">
                                    <span class="truncate-20" [matTooltip]="element.column_name" matTooltipPosition="above"
                                    matTooltipShowDelay="300">{{element.column_name}}</span>
                                </td>
                            </ng-container>

                            <ng-container matColumnDef="originalDescription">
                                <th mat-header-cell *matHeaderCellDef> Snowflake Description </th>
                                <td mat-cell *matCellDef="let element; let i = index">
                                    <span class="truncate-multiline" [matTooltip]="element.snowflake_description"
                                        matTooltipPosition="below" matTooltipClass="tooltip-wide">{{
                                        element.snowflake_description }}</span>
                                </td>
                            </ng-container>

                            <ng-container matColumnDef="customInstruction">
                                <th mat-header-cell *matHeaderCellDef> User Instruction </th>
                                <td mat-cell *matCellDef="let element; let i = index">
                                    @if (currentActiveRowIndex==i && enableEditing) {
                                    <mat-form-field appearance="outline"
                                        class="inline-field description-field small-height w-100 red-outline">
                                        <textarea matInput [(ngModel)]="element.user_instruction"
                                            placeholder="Enter Instruction" rows="1" maxlength="200">
                                                </textarea>
                                        <button mat-icon-button matSuffix matTooltip="Expand for detailed editing"
                                            (click)="openDescriptionDialog(item, element)" class="expand-btn">
                                            <mat-icon>open_in_full</mat-icon>
                                        </button>
                                        <mat-hint align="end">{{element.user_instruction?.length
                                            || 0}}/200</mat-hint>
                                    </mat-form-field>
                                    } @else {
                                    <span class="truncate-multiline" [matTooltip]="element.user_instruction"
                                        matTooltipPosition="below" matTooltipClass="tooltip-wide">{{
                                        element.user_instruction }}</span>
                                    }
                                </td>
                            </ng-container>

                            <ng-container matColumnDef="aiGeneratedDescription">
                                <th mat-header-cell *matHeaderCellDef> AI Generated Description </th>
                                <td mat-cell *matCellDef="let element; let i = index" class="description-cell">
                                    <span class="truncate-multiline" [matTooltip]="element.ai_generated_description"
                                        matTooltipPosition="below" matTooltipClass="tooltip-wide">{{
                                        element.ai_generated_description }}</span>
                                </td>
                            </ng-container>

                            <ng-container matColumnDef="aiGeneratedClassification">
                                <th mat-header-cell *matHeaderCellDef> AI Generated Classification </th>
                                <td mat-cell *matCellDef="let element; let i = index" class="classification-cell">
                                    <span class="classification-badge c1-badge"
                                        *ngIf="element.ai_generated_classification == 'C1'">{{
                                        element.ai_generated_classification }}</span>
                                    <span class="classification-badge c2-badge"
                                        *ngIf="element.ai_generated_classification == 'C2'">{{
                                        element.ai_generated_classification }}</span>
                                    <span class="classification-badge c3-badge"
                                        *ngIf="element.ai_generated_classification == 'C3'">{{
                                        element.ai_generated_classification }}</span>
                                    <span class="classification-badge c4-badge"
                                        *ngIf="element.ai_generated_classification == 'C4'">{{
                                        element.ai_generated_classification }}</span>
                                </td>
                            </ng-container>

                            <ng-container matColumnDef="aiReasoning">
                                <th mat-header-cell *matHeaderCellDef> AI Model Reasoning</th>
                                <td mat-cell *matCellDef="let element; let i = index">
                                    <span class="truncate-multiline" [matTooltip]="element.ai_reasoning"
                                        matTooltipPosition="below" matTooltipClass="tooltip-wide">{{
                                        element.ai_reasoning }}</span>
                                </td>
                            </ng-container>

                            <ng-container matColumnDef="confidenceScore">
                                <th mat-header-cell *matHeaderCellDef> Confidence Score </th>
                                <td mat-cell *matCellDef="let element; let i = index">
                                    <div class="confidence-score-container">
                                        @if(element.confidence_score<=30) { <mat-progress-bar color="warn"
                                            mode="determinate" value="{{element.confidence_score}}">
                                            </mat-progress-bar>&nbsp;&nbsp;<span
                                                class="score-text">{{element.confidence_score}}%</span>
                                            } @else if(element.confidence_score>30 && element.confidence_score<=60) {
                                                <mat-progress-bar color="accent" mode="determinate"
                                                value="{{element.confidence_score}}">
                                                </mat-progress-bar>&nbsp;&nbsp;<span
                                                    class="score-text">{{element.confidence_score}}%</span>
                                                } @else {
                                                <mat-progress-bar color="primary" mode="determinate"
                                                    value="{{element.confidence_score}}"></mat-progress-bar>&nbsp;&nbsp;<span
                                                    class="score-text">{{element.confidence_score}}%</span>
                                                }
                                    </div>
                                </td>
                            </ng-container>

                            <ng-container matColumnDef="action">
                                <th mat-header-cell *matHeaderCellDef> Action </th>
                                <td mat-cell *matCellDef="let element; let i = index">
                                    @if (currentActiveRowIndex==i && enableEditing) {
                                    <button class="action-btn save-action" (click)="saveRowData(i)">
                                        <span class="action-icon-container">
                                            <i class="fas fa-save action-icon"></i>
                                        </span>
                                    </button>
                                    } @else {
                                    <button class="action-btn" (click)="enableEdit(i)">
                                        <span class="action-icon-container">
                                            <i class="fas fa-edit"></i>
                                        </span>
                                    </button>
                                    }
                                </td>
                            </ng-container>

                            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                        </table>
                    </div>
                </mat-tab>
                }
            </mat-tab-group>
        </div>
        <ng-container *ngIf="descriptionLoading">
            <div class="loading-container">
                <svg viewBox="25 25 50 50">
                    <circle r="20" cy="50" cx="50"></circle>
                </svg>
                <br />
                <div class="loader-message">Regenerating...</div>
            </div>
        </ng-container>
    </div>
</div>

<!-- Column Description Dialog -->
<ng-template #columnDescriptionDialog>
    <div class="description-dialog">
        <h2 mat-dialog-title>
            <mat-icon>description</mat-icon>
            Description Editor
        </h2>

        <mat-dialog-content class="dialog-content">
            <mat-form-field appearance="outline" class="full-width-field small-height dialog-textarea-container">
                <mat-label>Detailed Description</mat-label>
                <textarea matInput [(ngModel)]="columnDescriptionFull"
                    placeholder="Provide a comprehensive description of this column, including its purpose, data sources, update frequency, and any important business context..."
                    rows="8" maxlength="200" class="description-textarea">
                </textarea>
                <mat-hint align="end">{{columnDescriptionFull.length || 0}}/200 characters</mat-hint>
            </mat-form-field>
        </mat-dialog-content>

        <mat-dialog-actions align="end" class="dialog-actions">
            <button mat-button (click)="closeDescriptionDialog()" class="cancel-btn">
                <mat-icon>close</mat-icon>
                Cancel
            </button>
            <button mat-button (click)="clearDescription()" class="clear-btn">
                <mat-icon>clear_all</mat-icon>
                Clear
            </button>
            <button mat-raised-button color="primary" (click)="saveDescription()" class="save-btn">
                <mat-icon>save</mat-icon>
                Save Description
            </button>
        </mat-dialog-actions>
    </div>
</ng-template>

<ng-template #downloadOptionDialog>
    <div class="description-dialog">
        <div class="classification-title px-3">
            <span>
                <i class="fa-solid fa-download"></i>
            </span>&nbsp;
            <span>Download</span>
        </div>

        <mat-dialog-content class="dialog-content dialog-download-content">
            <div class="download-buttons">
                <button class="btn btn-success generate-btn dialog-standard-btn" (click)="exportZip()">
                    <i class="fa-solid fa-save"></i>&nbsp;Standard Template
                </button>
                <button class="btn btn-primary generate-btn dialog-atlan-btn ms-3" (click)="atlanBulDownload()">
                    <i class="fa-solid fa-download"></i>&nbsp;Atlan Bulk Upload Template
                </button>
            </div>
        </mat-dialog-content>

        <mat-dialog-actions align="end" class="dialog-actions">
            <button mat-button (click)="closeDescriptionDialog()" class="cancel-btn">
                <mat-icon>close</mat-icon>
                Cancel
            </button>
        </mat-dialog-actions>
    </div>
</ng-template>